import gql from 'graphql-tag';

import remoteItemShareRoleFragment from '../fragments/remoteItemShareRoleFragment';

export default gql`
  query remoteItemShareRoles(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    remoteItemShareRoles(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...remoteItemShareRoleFragment
    }
  }
  ${remoteItemShareRoleFragment}
`;
